import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=2b5245c7"
import script from "./Imagenes.vue?vue&type=script&lang=js"
export * from "./Imagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports